import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { createUnitOccupancy, deleteUnitOccupancy, updateUnitOccupancy } from 'modules/_common/api';

export const useMutationOccupancySidebar = () => {
  const { t } = useTranslation();

  const queryClient = useQueryClient();
  const { successToast, errorToast } = useCustomToast();

  //createUnitOccupancy
  const { mutateAsync: createUnitOccupancyHandler, isLoading: isCreateHoldEventLoader } =
    useMutation(createUnitOccupancy, {
      onSuccess: () => {
        successToast();
        queryClient.refetchQueries(QUERY_KEYS.UNITS_RESERVATIONS);
        queryClient.invalidateQueries(
          QUERY_KEYS.UNITS_RESERVATIONS_AND_OCCUPANICES_EQUALS_TO_PROPERTY,
          {
            refetchInactive: true,
          },
        );
        queryClient.invalidateQueries(QUERY_KEYS.UNITS_UNIT_OCCUPANCY);
        queryClient.invalidateQueries(QUERY_KEYS.UNITS_OCCUPANCIES);
        queryClient.invalidateQueries(QUERY_KEYS.UNITS_CALENDAR_RESERVATIONS);
        queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATIONS_AND_OCCUPANICES);
        queryClient.invalidateQueries(QUERY_KEYS.LINE_CALENDAR_RESERVATIONS);
      },
      onError: (err: any) => {
        let error = '';

        const items = err?.response?.data?.Items;
        if (items) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          for (const [key, value] of Object.entries(items)) {
            error = value as string;
          }
        }

        const errorDescription = err?.response?.data?.ErrorDescription || '';
        if (errorDescription.startsWith('No price list defined')) {
          error = t('noPriceListDefinedOccupancyError');
        }

        errorToast(error);
      },
    });

  //updateUnitOccupancy
  const { mutateAsync: updateUnitOccupancyHandler, isLoading: isUpdateHoldEventLoader } =
    useMutation(updateUnitOccupancy, {
      onSuccess: () => {
        successToast();
        queryClient.refetchQueries(QUERY_KEYS.UNITS_RESERVATIONS);
        queryClient.invalidateQueries(
          QUERY_KEYS.UNITS_RESERVATIONS_AND_OCCUPANICES_EQUALS_TO_PROPERTY,
          {
            refetchInactive: true,
          },
        );
        queryClient.invalidateQueries(QUERY_KEYS.UNITS_UNIT_OCCUPANCY);
        queryClient.invalidateQueries(QUERY_KEYS.UNITS_OCCUPANCIES);
        queryClient.invalidateQueries(QUERY_KEYS.UNITS_CALENDAR_RESERVATIONS);
        queryClient.invalidateQueries(QUERY_KEYS.LINE_CALENDAR_RESERVATIONS);
        queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATIONS_AND_OCCUPANICES);
      },
      onError: (err: any) => {
        let error = '';

        const items = err?.response?.data?.Items;
        if (items) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          for (const [key, value] of Object.entries(items)) {
            error = value as string;
          }
        }

        // Message if no price list defined for given period
        const errorDescription = err?.response?.data?.ErrorDescription || '';
        if (errorDescription.startsWith('No price list defined')) {
          error = t('noPriceListDefinedOccupancyError');
        }

        errorToast(error);
      },
    });

  //deleteUnitOccupancy
  const { mutateAsync: deleteUnitOccupancyHandler, isLoading: isDeleteldEventLoader } = useMutation(
    deleteUnitOccupancy,
    {
      onSuccess: () => {
        successToast(t('The occupation has been successfully deleted'));
        queryClient.refetchQueries(QUERY_KEYS.UNITS_RESERVATIONS);
        queryClient.invalidateQueries(
          QUERY_KEYS.UNITS_RESERVATIONS_AND_OCCUPANICES_EQUALS_TO_PROPERTY,
          {
            refetchInactive: true,
          },
        );
        queryClient.invalidateQueries(QUERY_KEYS.UNITS_UNIT_OCCUPANCY);
        queryClient.invalidateQueries(QUERY_KEYS.UNITS_OCCUPANCIES);
        queryClient.invalidateQueries(QUERY_KEYS.UNITS_CALENDAR_RESERVATIONS);
        queryClient.invalidateQueries(QUERY_KEYS.UNITS_RESERVATIONS_AND_OCCUPANICES);
        queryClient.invalidateQueries(QUERY_KEYS.LINE_CALENDAR_RESERVATIONS);
      },
    },
  );

  return {
    createUnitOccupancyHandler,
    updateUnitOccupancyHandler,
    deleteUnitOccupancyHandler,
    isUpdatingOrCreatingHoldEvent:
      isUpdateHoldEventLoader || isCreateHoldEventLoader || isDeleteldEventLoader,
  };
};
